// extracted by mini-css-extract-plugin
export default {"status":"grh4J","subscript":"ymsjO","offer-button":"_2oSPo","offerButton":"_2oSPo"};